import type { MemberRole } from '../domain/access'

export type TripParticipant = Readonly<{
  id: string
  displayName: string
  role: MemberRole
}>

export type TripStage = Readonly<{
  id: string
  order: number
  name: string
  startsOn: string
  endsOn: string
  center: Readonly<{ latitude: number; longitude: number }>
}>

export type TripConfiguration = Readonly<{
  id: string
  name: string
  timeZone: 'Africa/Casablanca'
  startsOn: string
  endsOn: string
  participants: readonly TripParticipant[]
  stages: readonly TripStage[]
}>

export const CARAVAN_TRIP = Object.freeze({
  id: '0f6d9767-e552-4de5-8a8d-ff4a4152ad41',
  name: 'Caravan · Maroc 2026',
  timeZone: 'Africa/Casablanca',
  startsOn: '2026-09-05',
  endsOn: '2026-09-19',
  participants: Object.freeze([
    Object.freeze({ id: '11111111-1111-4111-8111-111111111111', displayName: 'Nicolas', role: 'admin' }),
    Object.freeze({ id: '22222222-2222-4222-8222-222222222222', displayName: 'Robin', role: 'participant' }),
    Object.freeze({ id: '33333333-3333-4333-8333-333333333333', displayName: 'Maïwenn', role: 'participant' }),
    Object.freeze({ id: '44444444-4444-4444-8444-444444444444', displayName: 'Pauline', role: 'participant' }),
    Object.freeze({ id: '55555555-5555-4555-8555-555555555555', displayName: 'Mathilde', role: 'participant' }),
    Object.freeze({ id: '66666666-6666-4666-8666-666666666666', displayName: 'Juliette', role: 'participant' }),
  ]),
  stages: Object.freeze([
    Object.freeze({ id: '92000000-0000-4000-8000-000000000001', order: 1, name: 'Marrakech', startsOn: '2026-09-05', endsOn: '2026-09-07', center: Object.freeze({ latitude: 31.6295, longitude: -7.9811 }) }),
    Object.freeze({ id: '92000000-0000-4000-8000-000000000002', order: 2, name: 'Imlil', startsOn: '2026-09-07', endsOn: '2026-09-09', center: Object.freeze({ latitude: 31.1369, longitude: -7.9181 }) }),
    Object.freeze({ id: '92000000-0000-4000-8000-000000000003', order: 3, name: 'Aït-Ben-Haddou', startsOn: '2026-09-09', endsOn: '2026-09-11', center: Object.freeze({ latitude: 31.047, longitude: -7.129 }) }),
    Object.freeze({ id: '92000000-0000-4000-8000-000000000004', order: 4, name: 'Agafay', startsOn: '2026-09-11', endsOn: '2026-09-12', center: Object.freeze({ latitude: 31.487, longitude: -8.1903 }) }),
    Object.freeze({ id: '92000000-0000-4000-8000-000000000005', order: 5, name: 'Essaouira', startsOn: '2026-09-12', endsOn: '2026-09-15', center: Object.freeze({ latitude: 31.5085, longitude: -9.7595 }) }),
    Object.freeze({ id: '92000000-0000-4000-8000-000000000006', order: 6, name: 'Marrakech', startsOn: '2026-09-15', endsOn: '2026-09-19', center: Object.freeze({ latitude: 31.6295, longitude: -7.9811 }) }),
  ]),
} as const satisfies TripConfiguration)
